import { render, staticRenderFns } from "./numbers.vue?vue&type=template&id=75a40928"
import script from "./numbers.vue?vue&type=script&lang=js"
export * from "./numbers.vue?vue&type=script&lang=js"
import style0 from "./numbers.vue?vue&type=style&index=0&id=75a40928&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports